var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row items-center"},[_c('div',{class:{
      'cursor-pointer': _vm.canReact,
      flex: true,
      'flex-row': true,
      'items-end': true,
      'text-dark-text-200': !_vm.isPadletColorSchemeDark,
      'text-light-text-200': _vm.isPadletColorSchemeDark,
      'hover-hover:hover:text-dark-text-100': !_vm.isPadletColorSchemeDark,
      'hover-hover:hover:text-light-text-100': _vm.isPadletColorSchemeDark,
      'hover-hover:focus:text-grape-500': !_vm.isPadletColorSchemeDark,
      'hover-hover:focus:text-canary-500': _vm.isPadletColorSchemeDark,
      'hover-hover:active:text-grape-500': !_vm.isPadletColorSchemeDark,
      'hover-hover:active:text-canary-500': _vm.isPadletColorSchemeDark,
    },on:{"click":_vm.toggleLike,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.toggleLike($event)}}},[_c('OzIcon',{class:[_vm.currentUserReacted && (_vm.isPadletColorSchemeDark ? 'text-canary-500' : 'text-grape-500')],attrs:{"size":18,"name":_vm.currentUserReacted ? 'heart_filled' : 'heart_outline'}}),_vm._v(" "),_c('span',{class:['ltr:ml-0.5 rtl:mr-0.5', 'text-12-16', 'font-sans']},[_vm._v("\n      "+_vm._s(_vm.reactionCount)+"\n    ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }